import { injectReducer } from '../../store/reducers';
import { injectSagas } from '../../store/sagas';

export default store => ({
  path: '/conferences/:id',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      const Counter = require('./containers/ConferenceProfileContainer').default;
      const reducer = require('reducers/conferences').default;
      const sagas = require('sagas/sagas').default;

      injectReducer(store, { key: 'conferences', reducer });
      injectSagas(store, { key: 'sagas', sagas });

      cb(null, Counter);
    }, 'ConferenceProfile');
  },
});



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/routes/ConferenceProfile/index.js